/* ==========================================================================
   WATCHFACTS BY NEXO — Mechanism Canvas Frame Animation (scroll-driven)
   Works on both desktop and mobile.
   ========================================================================== */

(function () {
  'use strict';

  function updateFeatures(section, progress) {
    var features = section.querySelectorAll('.wf-mechanism__feature');
    var steps    = features.length;
    var cta      = section.querySelector('.wf-mechanism__cta');

    features.forEach(function (f, i) {
      f.classList.toggle('is-active', progress >= (i + 1) / (steps + 1));
    });

    if (cta) cta.classList.toggle('is-active', progress >= 0.88);
  }

  // -------------------------------------------------------------------------
  // Shared canvas draw helper (cover-fit)
  // -------------------------------------------------------------------------
  function drawFrame(ctx, canvas, img) {
    if (!img || !img.complete || !img.naturalWidth) return;

    var cw = canvas.width;
    var ch = canvas.height;
    var iw = img.naturalWidth;
    var ih = img.naturalHeight;
    var scale = Math.max(cw / iw, ch / ih);
    var dw    = iw * scale;
    var dh    = ih * scale;

    ctx.clearRect(0, 0, cw, ch);
    ctx.drawImage(img, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
  }

  function resizeCanvas(canvas) {
    var parent = canvas.parentElement;
    canvas.width  = parent.offsetWidth  || 800;
    canvas.height = parent.offsetHeight || 800;
  }

  // -------------------------------------------------------------------------
  // Scroll-driven animation — desktop AND mobile
  // -------------------------------------------------------------------------
  function initScrollAnimation(section, canvas, images) {
    var ctx          = canvas.getContext('2d');
    var currentFrame = 0;
    var targetFrame  = 0;
    var rafPending   = false;

    function resize() {
      resizeCanvas(canvas);
      drawFrame(ctx, canvas, images[currentFrame]);
    }

    function applyFrame() {
      currentFrame = targetFrame;
      drawFrame(ctx, canvas, images[currentFrame]);
      rafPending = false;
    }

    function calcProgress() {
      var rect     = section.getBoundingClientRect();
      var sectionH = section.offsetHeight;
      var viewH    = window.innerHeight;
      var scrolled = -rect.top;
      var range    = sectionH - viewH;
      return range > 0 ? Math.min(1, Math.max(0, scrolled / range)) : 0;
    }

    function onScroll() {
      var progress = calcProgress();
      targetFrame  = Math.round(progress * (images.length - 1));

      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(applyFrame);
      }

      updateFeatures(section, progress);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', resize);

    resize();
    onScroll();
  }

  // -------------------------------------------------------------------------
  // Init
  // -------------------------------------------------------------------------
  function init() {
    var section = document.querySelector('.wf-mechanism');
    var canvas  = document.getElementById('wf-mechanism-canvas');
    var urls    = window.wfMechFrames;

    if (!section || !canvas || !urls || !urls.length) return;

    canvas.style.width   = '100%';
    canvas.style.height  = '100%';
    canvas.style.display = 'block';

    var images = urls.map(function (url) {
      var img = new Image();
      img.src = url;
      return img;
    });

    var first = images[0];
    if (first.complete && first.naturalWidth) {
      initScrollAnimation(section, canvas, images);
    } else {
      first.onload = function () {
        initScrollAnimation(section, canvas, images);
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
